import { combineReducers } from 'redux';
import menu from './menu/reducer';
import products from './products/reducer';
import merchant from './merchant/reducer';
import menuModal from './menuModal/reducer';
import events from './events/reducer';
import newMenu from './newMenu/reducer';
import categories from './categories/reducer';
import variations from './variations/reducer';
import productAddons from './productAddons/reducer';
import tags from './tags/reducer';
import scrollTo from './scroll/reducer';

export default combineReducers({
  menu,
  products,
  merchant,
  menuModal,
  events,
  newMenu,
  categories,
  variations,
  productAddons,
  tags,
  scrollTo,
});



// WEBPACK FOOTER //
// ./src/store/reducers.js